'use client'

import { useEffect } from 'react'
import { startQcoinRuntime } from '../lib/qcoinClientRuntime.js'

export default function QCoinRuntimeBridge() {
  useEffect(() => startQcoinRuntime(), [])
  return null
}
